module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', {
    attrs: {
      "label": _vm.required != null ? (_vm.label + '*') : _vm.label,
      "rows": _vm.rows,
      "auto-grow": true,
      "multi-line": "",
      "counter": _vm.counter,
      "rules": _vm.couterRules,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.setTexto()
      }
    },
    model: {
      value: (_vm.texto),
      callback: function($$v) {
        _vm.texto = $$v
      },
      expression: "texto"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82325296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-textarea.vue
// module id = 430
// module chunks = 0